import Quemsomos from '../components/templates/QuemSomos';

export default function QuemSomosPage() {
  return <Quemsomos />;
}
